import React from 'react'
import './styles.scss'

export default ({ children, className, ...props }) => (
    <button className="button {className}" {...props}>{ children }</button>
)
